// extracted by mini-css-extract-plugin
module.exports = {"author":"author-module--author--1QL3e","author__image":"author-module--author__image--1FLtM","author__content":"author-module--author__content--7B50Z"};